export default "__VITE_ASSET__b5dde274__"